const FLATICON = [
    {
        Category: "Programming Languages",
        Icon: `https://cdn-icons-png.flaticon.com/128/919/919852.png`,
        Source: "",
        Name: "python"
    },
    {
        Category: "Programming Languages",
        Icon: `https://cdn.worldvectorlogo.com/logos/logo-javascript.svg`,
        Source: "",
        Name: "JavaScript"
    },
    {
        Category: "Programming Languages",
        Icon: `https://cdn-icons-png.flaticon.com/128/226/226777.png`,
        Source: "",
        Name: "Java"
    },

    {
        Category: "Web Frameworks",
        Icon: `https://cdn-icons-png.flaticon.com/128/919/919825.png`,
        Source: "",
        name: "NodeJs"
    },
    {
        Category: "Web Frameworks",
        Icon: `https://cdn.worldvectorlogo.com/logos/react-2.svg`,
        Source: "",
        name: "ReactJs"
    },
    {
        Category: "Web Frameworks",
        Icon: `https://cdn.worldvectorlogo.com/logos/django-community.svg`,
        Source: "",
        name: "Django"
    },
    {
        Category: "Others",
        Icon: `https://cdn.worldvectorlogo.com/logos/bootstrap-4.svg`,
        Source: "",
        name: "Bootstrap"
    },
    {
        Category: "Others",
        Icon: `https://cdn.worldvectorlogo.com/logos/git.svg`,
        Source: "",
        name: "Git"
    },
    {
        Category: "Others",
        Icon: `https://cdn-icons-png.flaticon.com/128/5968/5968342.png`,
        Source: "",
        name: "PostgresSQL"
    },
    {
        Category: "Others",
        Icon: `https://cdn.worldvectorlogo.com/logos/mongodb-icon-1.svg`,
        Source: "",
        name: "MongoDB"
    },
    {
        Category: "Others",
        Icon: `https://cdn.worldvectorlogo.com/logos/firebase-1.svg`,
        Source: "",
        name: "Firebase"
    }
]

export default FLATICON